<template>
  <div style="min-width:1000px;">
    <section>
      <div class="jczl_div">
        <span class="jczl_span1">
          企业用户
        </span></br>
        <span class="jczl_span2">
          当前有 {{total}} 个企业用户
        </span>
      </div>
      <!--工具条-->
      <el-col :span="24" >
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <!-- <el-select class="souch_change" v-model="value" placeholder="请选择" @change="changeSouch" >
            <el-option v-for="item in options" :key="item.value"  
              :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
          <el-form-item>
              <el-input  v-model="searchText"  placeholder="账号 / 姓名 / 企业" style="width:180px;" clearable  @keyup.enter.native="getUser(1)"></el-input>
          </el-form-item>

           <el-form-item>
             <el-select  v-model="typeValue" placeholder="状态" style="width:140px" class="souch_change souch_input" clearable >
              <el-option v-for="item in types" :key="item.value" 
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
           </el-form-item>

           <el-form-item>
             <el-select  v-model="deptId" placeholder="部门" style="width:140px" class="souch_change souch_input" :clearable="isAdmin" >
              <el-option v-for="item in detpList" :key="item.value" 
                :label="item.deptname" :value="item.id">
              </el-option>
            </el-select>
           </el-form-item>

          <!-- <el-form-item>
            <el-input v-show="disSouch" class="souch_change souch_input" v-model="proName"  @keyup.enter.native="getUser(1)"></el-input>
            <el-select v-show="disType" v-model="typeValue" placeholder="请选择" style="width:200px" class="souch_change souch_input" clearable >
              <el-option v-for="item in types" :key="item.value" 
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item style="margin-left: 10px">
            <el-button type="primary" class="souch_but" v-on:click="getUser(1)">查询</el-button>
          </el-form-item>

          <el-form-item>
            <el-button  class="souch_but2" v-on:click="addList">添加</el-button>
          </el-form-item>
        </el-form>
        <!-- <el-tag :key="tag" v-for="tag in dynamicTags" closable 
          :disable-transitions="false" @close="handleClose(tag)"> 
            {{tag}} 
        </el-tag>
        <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button> -->
      </el-col>

      <!--列表-->
      <el-table  :data="userList" highlight-current-row v-loading="listLoading"  style="width: 100%;" 
        :header-cell-style="getRowClass" @selection-change="selsChange" @sort-change="handleSortChange">
        <el-table-column type="selection" width="55" :selectable='selectInit'>
			  </el-table-column>
        <el-table-column type="index" :index="indexMethod" label="序号" width="80">
          <template slot-scope="scope">
              <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="账号" min-width="140" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="100" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="point" label="积分" min-width="100" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="company" label="企业" min-width="180" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="deptname" label="部门" min-width="140" sortable="custom"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="invitestatusname" label="状态" min-width="180" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" min-width="200" style="text-algin:center">
          <template slot-scope="scope">
            <el-button type="danger" :disabled="scope.row.delShow" plain size="small" @click="batchRemove(scope.$index, scope.row)">移除</el-button>
           </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="toolbar" style="border:1px solid #dfe6ec;">
        <el-button type="danger" plain size="small" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>
        <el-pagination 
          background
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50,100]"
          :current-page="pageNumber" 
          @current-change="handleCurrentChange" 
          @size-change="handleSizeChange"
          :page-size="pageSize" 
          :total="total" 
          style="float:right;">
        </el-pagination>
      </el-col>

      <!--添加界面-->
      <el-dialog class="model-edit" title="添加" :visible.sync="addFormVisible" 
        :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-row>
            <el-col :span="22"> 
              <el-form-item label="手机号：" prop="phone">
                <el-input v-model="addForm.phone" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button class="qxsub" @click.native="addFormVisible = false">取消</el-button>
          <el-button class="addsub" type="primary" @click.native="addSubmit(addForm)" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

    </section>
  </div>
</template>
<script>
import { API__code,API_Company,API__account} from '../../../api/index.js'
export default {
  inject:['reload'],
  data(){
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        // const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
        const reg = /^1[3-9]\d{9}$/
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    return {
      searchText: '',
      deptId: '',
      listLoading: false,


      disSouch:true,
      disType:false,
      souchs:{
        phone:'',
        name:'',
        company:'',
        invitestatusname:'',
      },
      proName:'',
      typeValue:'',
      types: [
        {value: '1',label: '邀请中'}, 
        {value: '2',label: '邀请通过'},
      ],
      options: [
        {value: '账号',label: '账号'}, 
        {value: '姓名',label: '姓名'},
        {value: '企业',label: '企业'},
        {value: '状态',label: '状态'},
      ],
      value: '',
      dynamicTags:[],
      addFormVisible:false,
      addLoading:false,
      addForm:{},
      addFormRules: {
        phone: [
          {validator: checkPhone, trigger: 'blur'}
        ]
      },
      userList:[],
      pageSize:10,
      pageNumber:1,
      total:0,
      
      token:'',
      checkCode:'',
      id:'',
      companymanageid:'',
      sels:[],
      orderType:'',
      orderStr:'',

      detpList: [],
      isAdmin: false
    }
  },
  methods:{
    // handledel:function(index,row){
    //   let param ={
    //     id:row.id
    //   }
    // },
    handleSortChange:function(val){
      if(val){
        if(val.prop == "name"){
          this.orderStr = "namepx";
        }else if(val.prop == "phone"){
          this.orderStr = "phonepx";
        }else if(val.prop == "invitestatusname"){
          this.orderStr = "invitestatusnamepx";
        }else if(val.prop == "point"){
          this.orderStr = "pointpx";
        }else if(val.prop == "company"){
          this.orderStr = "companypx";
        }else if(val.prop=='deptname'){
          this.orderStr='deptpx'
        }
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getUser();
    },
    batchRemove:function(index,row){
      var ids;
      if(row){
        ids = row.id;
      }else{
        ids = this.sels.map(item => item.id).toString();
      }
      this.$confirm('确认删除选中记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        let para = { 
          token:this.token,
          checkCode:this.checkCode,
          companyid:this.companymanageid,
          userids: ids,
        };
        API_Company.delComUserList(para).then((res) => {
          this.listLoading = false;
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getUser();
        });
      });
    },
    selsChange: function (sels) {
			this.sels = sels;
    },
    selectInit:function(row,index){
      if(row.companymanageid || (row.deptList && row.deptList.length > 0)){
        return 0;//不可勾选
      }else{
        return 1;//可勾选
      }
    },
    delTags:function(){
      this.souchs = {},
      this.value = '';
      this.typeValue = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getUser();
    },
    handleClose(tag) {
      if(tag == "账号"){
        this.souchs.phone ="";
        if(this.value == "账号"){
          this.proName = '';
        }
      }
      if(tag == "姓名"){
        this.souchs.name ="";
        if(this.value == "姓名"){
          this.proName = '';
        }
      }
      if(tag == "企业"){
        this.souchs.company="";
        if(this.value == "企业"){
          this.proName = '';
        }
      }
      if(tag == "状态"){
        this.souchs.invitestatusname ="";
        this.typeValue = '';
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    changeSouch:function(val){
      if(val == "账号"){
        this.proName = this.souchs.phone;
        this.disSouch = true;
        this.disType = false;
      }else if(val == "姓名"){
        this.proName = this.souchs.name;
        this.disSouch = true;
        this.disType = false;
      }else if(val == "企业"){
        this.proName = this.souchs.company;
        this.disSouch = true;
        this.disType = false;
      }else if(val == "状态"){
        this.typeValue = this.souchs.invitestatusname;
        this.disSouch = false;
        this.disType = true;
      }
    },
    addSubmit:function(addForm){
      this.$refs.addForm.validate((valid) => {
        if (valid) {
            let param ={
              token:this.token,
              checkCode:this.checkCode,
              companymanagerid:this.id,
              phone:this.addForm.phone,
            }
            API_Company.addComList(param)
            .then((res) =>{
              if(res.data.code == API__code.SUCCESS){
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.addFormVisible = false;
                this.getUser();
              }else{
                this.$message.error(res.data.message);
                if(res.data.code == 403){
                  this.$router.push({path: 'login'});
                }
              }
            }).catch(err =>{
              this.$message.error('数据丢失，试试重新登陆！');
            });
            
        } else {
          console.log('error submit!!');
          return false;
        }
        
      });
      
    },
    addList:function(){
      this.addFormVisible = true;
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
          return "background:#F5F7FA";
      } else {
          return "";
      }
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getUser();
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getUser();
		},
    getUser:function(val){
      if(this.value == "账号"){
        this.souchs.phone = this.proName;
      }
      if(this.value == "姓名"){
        this.souchs.name = this.proName;
      }
      if(this.value == "企业"){
        this.souchs.company = this.proName;
      }
      if(this.value == "状态"){
        this.souchs.invitestatusname = this.typeValue;
      }
      var flag = true;
      if(val == 1){
        this.pageNumber = 1;
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }

      let _this = this;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        listType:'page',
        companyid:this.companymanageid,
        company:this.souchs.company,
        phone:this.souchs.phone,
        username: this.souchs.name,
        // invitestatus:this.souchs.invitestatusname,
        invitestatus: this.typeValue,
        orderType:this.orderType,
        orderStr:this.orderStr,
        searchText: this.searchText,
        // deptid: this.deptId
      }
      this.listLoading = true;
      API_Company.userList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data){
            for(var i=0;i<res.data.data.list.length;i++){
              if(res.data.data.list[i].companymanageid || res.data.data.list[i].deptList.length > 0){
                res.data.data.list[i].delShow = true;
              }else{
                res.data.data.list[i].delShow = false;
              }
            }
            _this.userList = res.data.data.list;
            _this.total = res.data.data.totalRow
          }
        }else{
          _this.$message.error(res.data.message);
          if(res.data.code == 403){
            _this.$router.push({path: 'login'});
          }
        }
        this.listLoading = false;
      }).catch(err =>{
        this.listLoading = false;
        _this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    
    // 查看部门
    getDeptList() {
      let param = {
        token:this.token,
        checkCode: this.checkCode,
        companyid: this.companymanageid,
        id: sessionStorage.getItem('dnnypt_id')
      }
      API_Company.getDeptListByUserId(param).then((res) =>{
        if(res.data.code == 200){
          this.detpList = res.data.data;
          this.deptId = this.detpList.length > 0? this.detpList[0].id: ''
        }
      }).catch(err =>{
        _this.$message.error('数据丢失，试试重新登陆！');
      })
    },

    //读取cookie
    getCookie: function() {
      this.id = sessionStorage.getItem('dnnypt_id');
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnypt_token') {
              this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnypt_checkCode') {
              this.checkCode = arr2[1];
          }
          // else if (arr2[0] == 'dnnypt_id') {
          //     this.id = arr2[1];
          // }
        }
      }
    },
    getDetial:function(){
      let _this = this;
      let params = {
        token:this.token,
        checkCode:this.checkCode,
        id:sessionStorage.getItem('dnnypt_id'),
      }
      API__account.accountDetail(params)
      .then((res)=>{
        if(res.data.code == API__code.SUCCESS){
           let data =  res.data.data;
           // 是否是超管
           this.isAdmin = data.companymanageid != null
          if(data.companymanageid || data.companyuseid) {
            // 部门管理员登录： 取companyuseid
            _this.companymanageid = data.companymanageid? data.companymanageid: data.companyuseid;
            _this.getUser();
          }else if(res.data.data.deptList && res.data.data.deptList.length > 0){
             _this.getUser();
          }else{
            this.$router.push({path: 'management'});
            this.reload();
          }
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'login'});
          }
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      });
    }
  },
  created(){
    this.getCookie();
    this.getDeptList();
  },
  mounted(){
    // this.companymanageid = sessionStorage.getItem('companymanageid');
    this.getDetial();
  },
}
</script>
<style lang="scss" scoped>
.souch_but{
  width:96px;
  background: #F66B3D;
  height: 40px;
  position: relative;
  left: -25px;
  border-radius: 0;
  border-color: #f66b3d;
  &:hover{
      background: #fc8b65;
      border-color: #fc8b65;
  }
}
.souch_but2{
  width:96px;
  background: #fff;
  height: 40px;
  position: relative;
  left: 0px;
  color:#F66B3D;
  border-radius: 0;
  border-color: #fff;
  &:hover{
      background: rgb(243, 229, 229);
      border-color: #fc8b65;
  }
}
.souch_input{
  width:200px;
  position: relative;
  left: -10px;
}
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-select {
    display: inline-block;
    position: relative;
    width: 115px;
}
.el-tag + .el-tag {
    margin-left: 10px;
}
.jczl_div{
    height: 100px;
    width: 100%;
    position: relative;
    left: 20px;
  }
.jczl_span1{
  font-size:20px;
  color:#666;
  font-weight:bold;
  position: relative;
  top:20px;
}
.jczl_span2{
  font-size:14px;
  color:#666;
  font-weight:normal;
  position: relative;
  top:30px;
}
.addsub{
  background: #F66B3D;
  border-color: #F66B3D;
  &:hover{
      background: #fc8b65;
      border-color: #fc8b65;
  }
}
.qxsub{
  background: #fff;
  color:#F66B3D;
  border-color: #fc8b65;
  &:hover{
      background: rgb(243, 229, 229);
      border-color: #fc8b65;
  }
}
</style>



// WEBPACK FOOTER //
// Company.vue?67baaf7b